import React, {CSSProperties, Fragment} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts'
import convertUnit from 'lib/unit'
import {Paragraph} from 'common/components'
import {TransactionDetailContentItemListSingleCreatorProps} from './TransactionDetailContentItemListSingleCreatorProps'
import TransactionDetailContentItemSingleCreator from './TransactionDetailContentItemSingleCreator'
import TransactionDetailPackageItemSingleCreator from './TransactionDetailPackageItemSingleCreator'

const StyledContentSection = styled.div<CSSProperties>`
  display: flex;
  flex-direction: column;
  margin: 0 ${convertUnit(25)};
  gap: 0;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    margin: 0;
  }
`

export default function TransactionDetailContentItemListSingleCreator({
  contents,
  packages,
  onClickItem,
  showDiscount,
  style,
  topElement,
  underTitleElement,
}: TransactionDetailContentItemListSingleCreatorProps) {
  const {translate} = useTranslation()
  return (
    <StyledContentSection style={style}>
      {topElement}
      <Paragraph fontWeight="bold" fontSize="xl">
        {translate('giftShop:contentDetail')}
      </Paragraph>
      {underTitleElement}
      {packages.map((item) => (
        <Fragment key={item.id}>
          <TransactionDetailPackageItemSingleCreator
            content={item}
            showDiscount={showDiscount}
          />
        </Fragment>
      ))}
      {contents.map((item) => (
        <Fragment key={item.id}>
          <TransactionDetailContentItemSingleCreator
            content={item}
            showDiscount={showDiscount}
            onClickItem={() => onClickItem(item)}
          />
        </Fragment>
      ))}
    </StyledContentSection>
  )
}
